var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "tit": "근무지 근무 현황"
    }
  }, [_c('template', {
    slot: "contents"
  }, [_c('v-badge', {
    attrs: {
      "floating": "",
      "dot": ""
    }
  }, [_c('h4', {
    staticClass: "tit--sm line-height-1"
  }, [_vm._v("근무 현황 조회")])]), _c('worker-company-filter', {
    staticClass: "mt-12 mt-lg-20",
    attrs: {
      "places": _vm.places
    }
  }), _c('worker-company-list', {
    staticClass: "mt-12 mt-lg-20"
  })], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }